(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/bet-events/assets/participant.js') >= 0) return;  svs.modules.push('/components/tipsen/bet-events/assets/participant.js');
"use strict";


const _svs$lb_ui = svs.lb_ui,
  getFlag = _svs$lb_ui.flags.getFlag,
  ReactFlag = _svs$lb_ui.ReactFlag;
const hasFlagRepresentation = iso => {
  const url = getFlag(iso);
  return url !== 'no-flag-found.svg';
};
const Participant = _ref => {
  let className = _ref.className,
    flagISO = _ref.flagISO,
    name = _ref.name,
    style = _ref.style;
  return React.createElement("div", {
    "aria-hidden": true,
    className: ['pg_bet_event__participant'].concat(className !== null && className !== void 0 ? className : []).join(' '),
    style: style
  }, flagISO && React.createElement("div", {
    className: "pg_bet_event__participant__flag"
  }, hasFlagRepresentation(flagISO) && React.createElement(ReactFlag, {
    iso: flagISO
  })), React.createElement("div", {
    className: "pg_bet_event__participant__name"
  }, name));
};
setGlobal('svs.components.tipsen.betEvents.Participant', Participant);

 })(window);